import { defineComponent as _defineComponent } from 'vue'
import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import type { PropType } from 'vue'
  import useBreakpoint from '@/composables/useBreakpoint'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GuidedQuizResults',
  props: {
    points: {
      required: true,
      type: Object as PropType<{ correct: number; wrong: number }>,
    },
    showTransition: {
      type: Boolean,
      default: true,
    },
  },
  setup(__props) {

  

  const { checkedCheckboxSquareWhite, wrongAnswerIcon } = useIcons()
  const { isMobileDevice } = useBreakpoint()

return { __sfc: true,checkedCheckboxSquareWhite, wrongAnswerIcon, isMobileDevice, SVGRenderer, useIcons, useBreakpoint }
}

})